var map = {
	"./i1.svg": "78be",
	"./i10.svg": "2488",
	"./i11.svg": "9197",
	"./i2.svg": "ee74",
	"./i3.svg": "0203",
	"./i4.svg": "13ed",
	"./i5.svg": "8dd1",
	"./i6.svg": "3d1d",
	"./i7.svg": "4b3f",
	"./i8.svg": "41e6",
	"./i9.svg": "1908"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";